import { Permission, PrivilegeType } from './role';

const ID_TOKEN_KEY = 'accessToken';

/** 模块基础权限对应的范围读权限（GLOBAL / DIRECT_DEPT） */
const MODULE_SCOPE_READ_PRIVILEGES: Partial<Record<PrivilegeType, PrivilegeType[]>> = {
  [PrivilegeType.PLAN]: [PrivilegeType.PLAN_GLOBAL, PrivilegeType.PLAN_DIRECT_DEPT],
  [PrivilegeType.PROJECT]: [PrivilegeType.PROJECT_GLOBAL, PrivilegeType.PROJECT_DIRECT_DEPT],
  [PrivilegeType.INTERNAL_TRADE]: [
    PrivilegeType.INTERNAL_TRADE_GLOBAL,
    PrivilegeType.INTERNAL_TRADE_DIRECT_DEPT,
  ],
  [PrivilegeType.OPERATIONAL_STATEMENT_TRANSACTION]: [
    PrivilegeType.OPERATIONAL_STATEMENT_TRANSACTION_GLOBAL,
    PrivilegeType.OPERATIONAL_STATEMENT_TRANSACTION_DIRECT_DEPT,
  ],
  [PrivilegeType.EXPENSE_ANALYSIS]: [
    PrivilegeType.EXPENSE_ANALYSIS_GLOBAL,
    PrivilegeType.EXPENSE_ANALYSIS_DIRECT_DEPT,
  ],
  [PrivilegeType.VARIANCE_ANALYSIS]: [
    PrivilegeType.VARIANCE_ANALYSIS_GLOBAL,
    PrivilegeType.VARIANCE_ANALYSIS_DIRECT_DEPT,
  ],
  [PrivilegeType.INCOME_ANALYSIS]: [
    PrivilegeType.INCOME_ANALYSIS_GLOBAL,
    PrivilegeType.INCOME_ANALYSIS_DIRECT_DEPT,
  ],
  [PrivilegeType.PROPOSAL]: [PrivilegeType.PROPOSAL_GLOBAL, PrivilegeType.PROPOSAL_DIRECT_DEPT],
  [PrivilegeType.ACTION_PLAN]: [
    PrivilegeType.ACTION_PLAN_GLOBAL,
    PrivilegeType.ACTION_PLAN_DIRECT_DEPT,
  ],
  [PrivilegeType.SUPPORT_REQUEST]: [
    PrivilegeType.SUPPORT_REQUEST_GLOBAL,
    PrivilegeType.SUPPORT_REQUEST_DIRECT_DEPT,
  ],
};

export const getToken = () => window.localStorage.getItem(ID_TOKEN_KEY);

export const saveToken = (token: string) => window.localStorage.setItem(ID_TOKEN_KEY, token);

export const destroyToken = () => window.localStorage.removeItem(ID_TOKEN_KEY);

export const isAllowedTo = (
  key: PrivilegeType,
  permissions?: Permission,
  requireWrite?: boolean
) => {
  if (!permissions) {
    return false;
  }

  if (requireWrite) {
    return !!permissions[key]?.write;
  }

  if (permissions[key]?.read || permissions[key]?.write || permissions[key]?.approve) {
    return true;
  }

  const scopePrivileges = MODULE_SCOPE_READ_PRIVILEGES[key];
  return !!scopePrivileges?.some((scopeKey) => permissions[scopeKey]?.read);
};
